// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextField__content-c0e89e {
  height: 52px;
}

.TextField__with-suffix-d2e7d4 .TextField__content-c0e89e {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.TextField__with-suffix-d2e7d4 .TextField__input-wrapper-d264b2 {
  flex: 1;
}

.TextField__suffix-f14936 {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 0 12px 0 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/TextField/TextField.style.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".content {\n  height: 52px;\n}\n\n.with-suffix .content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.with-suffix .input-wrapper {\n  flex: 1;\n}\n\n.suffix {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 12px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TextField__content-c0e89e`,
	"with-suffix": `TextField__with-suffix-d2e7d4`,
	"withSuffix": `TextField__with-suffix-d2e7d4`,
	"input-wrapper": `TextField__input-wrapper-d264b2`,
	"inputWrapper": `TextField__input-wrapper-d264b2`,
	"suffix": `TextField__suffix-f14936`
};
module.exports = ___CSS_LOADER_EXPORT___;
